module.exports = __webpack_public_path__ + "img/icontaawun.df55e67a.png";